export function getDetailsReportDefinition(key) {
    const base64 = key.substring(key.length - 6, key.length) + key.substring(0, key.length - 6);
    const bits = Buffer.from(base64, 'base64').toString().split('###');
    return {
        id: bits[0],
        organisationId: bits[1],
        stamp: bits[2],
        type: bits[3],
        token: bits[4],
        pdf: bits[5] === 'PDF',
    };
}
